/**
 * Formata mensagens de falha de requisição P2P para serem exibidas no console e nas estatísticas.
 * @param {Object} params
 * @param {"binance"|"gate"|"bybit"|"bitget"|"kucoin"} params.exchange
 * @param {"BRL"|"BOB"} params.fiat
 * @param {"BUY"|"SELL"} params.side
 * @param {string} [params.fallback]
 * @param {any} [params.error]
 * @returns {string}
 */
export function formatRequestError({ exchange, fiat, side, fallback = "Indisponível", error }) {
  const context = `${exchange} ${fiat} ${side}`;
  if (import.meta.env.MODE === "development") {
    console.debug(`[P2P][${context}] requisição falhou`, {
      status: error?.response?.status,
      message: error?.message,
      payload: error?.response?.data ?? error,
    });
  }

  const status = error?.response?.status;
  if (status) {
    return `${fallback} (${status})`;
  }
  if (error?.message) {
    return `${fallback}: ${error.message}`;
  }
  return fallback;
}
